import '../../styles/components/load-more-pagination.scss';

class LoadMorePagination extends HTMLElement {
  constructor() {
    super();

    this.loadMoreContent = this.querySelector('[data-load-more-content]');

    this.loadPreviousButtonParent = this.querySelector('[data-prev-page-parent]');
    this.loadPreviousButton = this.querySelector('[data-prev-page]');
    this.loadMoreButton = this.querySelector('[data-next-page]');
    this.loadMoreCount = this.querySelector('[data-load-more-count]');

    this.loadPreviousButton?.addEventListener('click', this.onLoadClick.bind(this, 'prev'));
    this.loadMoreButton?.addEventListener('click', this.onLoadClick.bind(this, 'next'));
  }

  async onLoadClick(direction, event) {
    event.preventDefault();
    this.classList.add('loading');

    const isPrev = direction == 'prev' ? 'true' : false;

    const currentButton = event.currentTarget;
    const page = currentButton.href;
    const paginationUpdate = await fetch(page);
    const paginationUpdateText = await paginationUpdate.text();

    const parsedHtml = new DOMParser().parseFromString(paginationUpdateText, 'text/html');

    const newContent = parsedHtml.querySelector('load-more-pagination');

    const newElements = Array.from(newContent.querySelectorAll('[data-load-more-content] > *'));

    if (isPrev) {
      newElements.reverse();
    }

    newElements.forEach(element => {
      if (isPrev) {
        this.loadMoreContent.prepend(element);
      } else {
        this.loadMoreContent.append(element);
      }
    });

    this.loadMoreCount.innerHTML = parseInt(this.loadMoreCount.innerHTML) + parseInt(newContent.querySelector('[data-load-more-count]').innerHTML);

    if (newContent.querySelector(`[data-${direction}-page]`)) {
      currentButton.href = newContent.querySelector(`[data-${direction}-page]`).href;
    } else {
      if (isPrev) {
        this.loadPreviousButtonParent.remove();
      } else {
        this.loadMoreButton.remove();
      }
    }

    // Only remove ?page=1 for collection pages (check if URL contains /collections/)
    // Keep ?page=2, ?page=3, etc. for proper navigation and bookmarking
    const url = new URL(page);
    const isCollectionPage = url.pathname.includes('/collections/');
    const pageParam = url.searchParams.get('page');
    
    if (isCollectionPage && (pageParam === '1' || pageParam === null)) {
      url.searchParams.delete('page');
    }
    const cleanUrl = url.toString();

    window.history.pushState(null, null, cleanUrl);

    this.classList.remove('loading');
  }
}

try {
  customElements.define('load-more-pagination', LoadMorePagination);
}
catch(e) {}
